import { h } from "preact";
import siteSettings, { hasConfiguredSubstack } from "./siteSettings";
import luisianaWorlds from "../images/luisiana-worlds.jpg";
import "./corner_styles.css";

const drafts = [
  "Why does almost every engineer on my team play guitar?",
  "What do AI metrics even measure?",
  "Why I pay for Both Apple Music and Spotify",
  "The smartest engineer I've ever worked with",
  "The feeling that keeps me programming"
];

export default function BlogPage() {
  return (
    <main class="corner-page content-page narrow-page">
      <p class="eyebrow">Writing</p>
      <h1>Things I couldn't stop thinking about</h1>
      <p class="page-intro">Most of these essays begin with a question that refuses to leave me alone. The rest are observations, stories, or ideas I wanted to write down before I forgot them.</p>
      <p class="substack-note">Some are about software. Some are about everything else.</p>
      {hasConfiguredSubstack ? (
        <a class="primary-link" href={siteSettings.substackUrl} target="_blank" rel="noopener noreferrer">Check out my Substack <span class="link-arrow" aria-hidden="true"></span></a>
      ) : (
        <p class="setup-note">Add your publication URL in <code>src/siteSettings.js</code> to connect this page to your Substack.</p>
      )}
      <section class="writing-drafts">
        <p class="eyebrow">Things I'm still thinking about</p>
        <h2>Here's a preview of what's currently taking up space in my brain:</h2>
        <ul>
          {drafts.map((draft) => <li key={draft} data-scroll-reveal>{draft}</li>)}
        </ul>
      </section>
      <figure class="writing-photo" data-scroll-photo><img src={luisianaWorlds} alt="Louisiana Museum of Modern Art in Humlebæk, Denmark" /><figcaption>Humlebæk, Denmark</figcaption></figure>
    </main>
  );
}
